import { render, staticRenderFns } from "./RoomSettingsPanel.vue?vue&type=template&id=64534f50&"
import script from "./RoomSettingsPanel.vue?vue&type=script&lang=js&"
export * from "./RoomSettingsPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports